export default {
    dependencies: ['$element'],
    callable(ele) {
        // Empty touch handler to workaround iOS bug for off-screen elements
        // http://stackoverflow.com/a/18737266
        // Unsure which versions are affected, but 9 is not
        if (/OS [5-8]_.* like Mac OS X/.test(window.navigator.userAgent)) {
            ele.addEventListener('touchstart', () => {});
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/iosTouchWorkaround.js